module.exports = [
   {
      key: 'default',
      strRtf: '\\uc0\\u8226',
   },
   {
      key: 'circle',
      strRtf: '\\uc0\\u9702',
   },
   {
      key: 'square',
      strRtf: '\\uc0\\u9642',
   },
   {
      key: 'number',
      strRtf: '',
   },
   {
      key: 'upper-alpha',
      strRtf: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
   },
   {
      key: 'lower-alpha',
      strRtf: ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],
   },
];
